module.exports = __webpack_public_path__ + "img/ed-logo.fa2413e2.png";